/** Mismos códigos que la APP (cap4). Etiqueta visible: «ES - España». */
export const PAISES_DOMICILIO = [
  { code: "ES", nombre: "España" },
  { code: "FR", nombre: "Francia" },
  { code: "PT", nombre: "Portugal" },
  { code: "DE", nombre: "Alemania" },
  { code: "IT", nombre: "Italia" },
  { code: "GB", nombre: "Reino Unido" },
  { code: "BE", nombre: "Bélgica" },
  { code: "NL", nombre: "Países Bajos" },
  { code: "CH", nombre: "Suiza" },
  { code: "AD", nombre: "Andorra" },
  { code: "MA", nombre: "Marruecos" },
  { code: "OTHER", nombre: "Otro" },
];

/** Código corto (ES / OT). */
export function codigoCortoPaisDomicilio(code) {
  return code === "OTHER" ? "OT" : String(code || "ES").toUpperCase();
}

/** Como idioma («ES - Español»): «ES - España». */
export function etiquetaPaisDomicilio(code) {
  const c = String(code || "ES").toUpperCase();
  const found = PAISES_DOMICILIO.find((p) => p.code === c) || PAISES_DOMICILIO[0];
  return `${codigoCortoPaisDomicilio(found.code)} - ${found.nombre}`;
}

export function normalizarPaisDomicilio(raw) {
  const c = String(raw || "ES").trim().toUpperCase();
  if (!c) return "ES";
  if (PAISES_DOMICILIO.some((p) => p.code === c)) return c;
  if (/^[A-Z]{2}$/.test(c)) return "OTHER";
  return "ES";
}
